<div class="modal-container relative px-xl">
  @let item = data.item;
  <div class="flex items-center gap-sm sticky top-0 pt-lg pb-base bg-contrast z-1000">
    <svg-icon key="bell" class="text-sm! text-primary"></svg-icon>
    <span class="flex-1 text-2xs leading-2xs font-semibold uppercase tracking-[0.12em] text-primary">
      Announcement
    </span>
    <button
      type="button"
      class="flex shrink-0 text-txt-secondary hover:text-txt"
      (click)="closeDialog()"
      aria-label="Close"
    >
      <svg-icon key="close" class="text-sm!"></svg-icon>
    </button>
  </div>

  <div class="text-xl leading-xl text-txt font-semibold">{{ item.title }}</div>

  <div class="mt-base flex items-center gap-base">
    <div
      class="shrink-0 w-[32px] h-[32px] rounded-full flex items-center justify-center text-base leading-base font-semibold text-white"
      [style.background-color]="commonService.getAvatarColor(item.senderName)"
    >
      {{ commonService.getInitials(item.senderName) }}
    </div>
    <div class="text-sm leading-sm text-txt-disabled">
      {{ item.senderName }} ·
      {{ item.sentDate | llaUtcToLocalDate | date: 'MMM d, y' }}
    </div>
  </div>

  <div
    class="mt-lg pt-lg border-t border-ui-separator text-base leading-lg text-txt lla-rich-text"
    [innerHTML]="item.body | llaRichText"
  ></div>

  @if (item.imageUrls?.length) {
    <div class="mt-xl flex flex-wrap items-start gap-2xl">
      @for (imageUrl of item.imageUrls; track imageUrl) {
        <button
          type="button"
          class="flex cursor-pointer"
          (click)="lightboxIndex.set($index)"
          aria-label="View image"
        >
          <img
            class="max-w-[320px] max-h-[320px] rounded-base border border-ui-separator"
            [src]="imageUrl"
            alt="Announcement image"
          />
        </button>
      }
    </div>
  }

  <div
    class="mt-2xl py-base sticky bottom-0 bg-contrast z-1000 border-t border-ui-separator flex items-center justify-between gap-base"
  >
    <button
      type="button"
      class="flex items-center gap-sm px-base py-sm -ml-base rounded-sm text-sm leading-sm text-primary hover:bg-ui-hover"
      (click)="viewInAnnouncements()"
    >
      Open in Announcements
      <svg-icon key="arrow-right" class="text-sm!"></svg-icon>
    </button>
    <lla-button size="small" (click)="closeDialog()">Got it</lla-button>
  </div>

  @let lightboxIdx = lightboxIndex();
  @if (lightboxIdx !== undefined && item.imageUrls?.length) {
    <lla-image-lightbox
      [images]="item.imageUrls ?? []"
      [initialIndex]="lightboxIdx"
      (closed)="lightboxIndex.set(undefined)"
    ></lla-image-lightbox>
  }
</div>
